import { createSlice } from "@reduxjs/toolkit";
import image1 from "./../../../assets/images/event/evento-1.jpg";
import image2 from "./../../../assets/images/event/evento-2.jpg";
import image3 from "./../../../assets/images/event/evento-3.jpg";
import image4 from "./../../../assets/images/event/evento-4.jpg";
import image5 from "./../../../assets/images/event/evento-5.jpg";
import image6 from "./../../../assets/images/event/evento-6.jpg";

import a1 from "./../../../assets/images/avatars/1.png";
import a2 from "./../../../assets/images/avatars/2.png";
import a3 from "./../../../assets/images/avatars/3.png";
import a4 from "./../../../assets/images/avatars/4.png";
import a5 from "./../../../assets/images/avatars/5.png";
import a6 from "./../../../assets/images/avatars/6.png";
import a7 from "./../../../assets/images/avatars/7.png";
import a8 from "./../../../assets/images/avatars/8.png";
import a9 from "./../../../assets/images/avatars/9.png";
import a10 from "./../../../assets/images/avatars/10.png";
import a11 from "./../../../assets/images/avatars/11.png";
import a12 from "./../../../assets/images/avatars/12.png";

function isSmartphone() {
  const userAgent = navigator.userAgent;
  return /iPhone|iPad|iPod|Android/i.test(userAgent);
}

export const constSlice = createSlice({
  name: "globalConst",
  initialState: {
    eventId: "",
    titleView: "",
    switchNav: true,
    currentMail: "",
    errorMessage: "",
    detailsParams: {},
    errorHandled: false,
    resendShowModal: false,
    isSmartphone: isSmartphone(),
    resendModalParams: [
      { show: false, email: "", view: "", id: "", eventId: "" },
    ],
    filterModalParams: {
      view: "",
      data: [],
      args: {},
      filters: {},
      show: false,
      disable: true,
      filtersToShow: [],
    },
    filterModalParamsAtt: {
      show: false,
      view: "",
      data: "",
      args: {},
      state: [],
      select: {},
      disable: true,
    },
    eventImg: [
      {
        image: image1,
      },
      {
        image: image2,
      },
      {
        image: image3,
      },
      {
        image: image4,
      },
      {
        image: image5,
      },
      {
        image: image6,
      },
    ],
    avatarImg: [
      {
        image: a1,
      },
      {
        image: a2,
      },
      {
        image: a3,
      },
      {
        image: a4,
      },
      {
        image: a5,
      },
      {
        image: a6,
      },
      {
        image: a7,
      },
      {
        image: a8,
      },
      {
        image: a9,
      },
      {
        image: a10,
      },
      {
        image: a11,
      },
      {
        image: a12,
      },
    ],
    csvConverterModal: false,
    jsonData: [],
    jsonDataBack: [],
    jsonDataHeaders: [],
    headers: [
      { name: "PRIMER_NOMBRE", priority: true },
      // { name: 'SEGUNDO_NOMBRE', priority: false },
      { name: "APELLIDOS", priority: true },
      { name: "CORREO", priority: true },
      { name: "SUSCRIPCION", priority: true },
      // { name: "TELEFONO", priority: false },
      // { name: "CIUDAD", priority: false },
      // { name: "ESTADO", priority: false },
      // { name: "PAIS", priority: false },
      // { name: "CODIGO_POSTAL", priority: false }
    ],
    dayLabels: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
    monthLabels: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    dataTableClasicStyles: {
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
          backgroundColor: "#FFF9F2",
          borderTopStyle: "solid",
          borderBottomStyle: "solid",
          borderColor: "#FFD7A9",
          borderWidth: "1px",
          color: "#FF8800",
        },
      },
    },
    reactSelectStyles: {
      control: (styles) => ({ ...styles, backgroundColor: "white" }),
  
      multiValue: (styles) => {
        return {
          ...styles,
          backgroundColor: "orange",
        };
      },
      multiValueLabel: (styles) => ({
        ...styles,
        color: "orange",
      }),
      multiValueRemove: (styles) => ({
        ...styles,
        color: "white",
      }),
    }
  },
  reducers: {
    setHeaders: (state, action) => {
      state.headers = action.payload;
    },
    setJsonData: (state, action) => {},
    setJsonDataBack: (state, action) => {
      const { payload } = action;
      state.jsonData = payload;
      state.jsonDataBack = payload;
    },
    setJsonDataHeaders: (state, action) => {
      state.jsonDataHeaders = action.payload;
    },
    setCsvConverterModal: (state, action) => {
      state.csvConverterModal = action.payload;
    },
    setTitleView: (state, action) => {
      state.titleView = action.payload;
      state.detailsParams = {};
    },
    setSwitchNav: (state, action) => {
      const { status } = action.payload;
      state.switchNav = status;
    },
    setErrorHandled: (state, action) => {
      state.errorHandled = action.payload;
    },
    setResendShowModal: (state, action) => {
      state.resendShowModal = action.payload;
    },
    setCurrentMail: (state, action) => {
      state.currentMail = action.payload;
    },
    setResendModalParams: (state, action) => {
      state.resendModalParams = action.payload;
    },
    setEventId: (state, action) => {
      state.eventId = action.payload;
    },
    setFilterModalParams: (state, action) => {
      state.filterModalParams = action.payload;
    },
    setFilterModalParamsAtt: (state, action) => {
      state.filterModalParamsAtt = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setDetailsParams: (state, action) => {
      state.titleView = "";
      state.detailsParams = action.payload;
    },
  },
});

export const {
  setEventId,
  setHeaders,
  setJsonData,
  setSwitchNav,
  setTitleView,
  setCurrentMail,
  setJsonDataBack,
  setErrorMessage,
  setErrorHandled,
  setDetailsParams,
  setResendShowModal,
  setJsonDataHeaders,
  setResendModalParams,
  setFilterModalParams,
  setCsvConverterModal,
  setFilterModalParamsAtt,
} = constSlice.actions;

export default constSlice.reducer;
